import { BrowserRouter } from "react-router";

// Побочный эффект: инициализация i18next. Живёт в слое app, а не в main.tsx,
// потому что это часть настройки приложения — и потому что иначе тесты,
// рендерящие <App/> напрямую, получали бы вместо текстов ключи.
import "@/shared/i18n";

import { ToastProvider } from "@/shared/ui";

import { ErrorBoundary, ModeProvider, QueryProvider, TelegramProvider } from "./providers";
import { AppRoutes } from "./routes";
import { AuthGate } from "./ui/AuthGate";
import { OfflineOverlay } from "./ui/OfflineOverlay";

/**
 * BrowserRouter, а не Hash. Telegram передаёт параметры запуска во фрагменте
 * URL (`#tgWebAppData=…`, `tgWebAppStartParam`), откуда их читает SDK.
 * Hash-роутер переписал бы фрагмент под свои нужды и параметры запуска
 * потерялись бы при первой же навигации. Ценой становится правило
 * `try_files $uri /index.html` в проде — оно закладывается в FE-12.
 */
export function App() {
  return (
    <ErrorBoundary>
      <TelegramProvider>
        <QueryProvider>
          <ModeProvider>
            <ToastProvider>
              <BrowserRouter>
                <AuthGate>
                  <AppRoutes />
                </AuthGate>
                <OfflineOverlay />
              </BrowserRouter>
            </ToastProvider>
          </ModeProvider>
        </QueryProvider>
      </TelegramProvider>
    </ErrorBoundary>
  );
}
